const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "user"
}

const videoDimensions = {
    height: 240,
    width: 320 
}

const imgDimensions = {
    height: 168,
    width: 300
}

export {
    videoConstraints,
    videoDimensions,
    imgDimensions
}